export enum DateFormat {
    DDMMYYYY = 'DD/MM/YYYY',
    MMDDYYYY = 'MM/DD/YYYY'
}